import React, { useContext } from 'react';
import {
  CardBody,
  Typography
} from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { string } from 'prop-types';
import CompactNullView from './CompactNullView';
import DesktopNullView from './DesktopNullView';
import fallbackViewTexts from '../../../constants/fallbackViewTexts';
import { showAboveSmBreakpoint, showBelowSmBreakpoint } from '../../../constants/responsiveClassNames';

const QuotesNullView = ({ componentId }) => {
  const experienceContext = useContext(ExperienceContext);
  const { channel } = experienceContext;
  const isMobile = channel === 'mobile';
  const {
    benefits, cardTitle,
    imageAlt, imageUrl, learnMoreText
  } = fallbackViewTexts;

  const cardBody = (
    <CardBody>
      <ul
        className="sui-list-disc sui-list-outside sui-ml-4 sui-mb-0 sui-pb-4"
      >
        {benefits?.map((benefit, index) => (
          <li key={index}>
            <Typography>{benefit}</Typography>
          </li>
        ))}
      </ul>
    </CardBody>
  );

  return (
    <div className="sui-@container sui-h-full">
      {isMobile ? (
        <div className="sui-h-full">
          <CompactNullView
            cardBody={cardBody}
            imageUrl={imageUrl}
            imageAlt={imageAlt}
            cardTitle={cardTitle}
            learnMoreText={learnMoreText}
            componentId={componentId}
          />
        </div>
      ) : (
        <div className="sui-h-full">
          <DesktopNullView
            cardBody={cardBody}
            imageUrl={imageUrl}
            imageAlt={imageAlt}
            cardTitle={cardTitle}
            learnMoreText={learnMoreText}
            componentId={componentId}
          />
        </div>
      )}
    </div>
  );
};

QuotesNullView.propTypes = {
  componentId: string,
};

QuotesNullView.defaultProps = {
  componentId: '',
};

export default QuotesNullView;
